import Navigation from "@/components/Navigation";

const FUEHairRestoration = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-serif mb-8">FUE Hair Restoration</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <img
                src="/lovable-uploads/57b53a43-b8f1-43f8-ba01-417c651840b0.png"
                alt="FUE Hair Restoration"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
            </div>
            <div>
              <p className="text-lg mb-6">
                Follicular Unit Extraction (FUE) is an advanced hair restoration technique that provides natural-looking results with minimal scarring.
              </p>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">The Procedure</h3>
                  <p>Individual follicular units are extracted and transplanted for natural results.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Benefits</h3>
                  <p>Minimal scarring, quick recovery, and permanent results.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Recovery</h3>
                  <p>Most patients return to normal activities within a week.</p>
                </div>
              </div>
              <a
                href="https://na02.patientnow.com/a/EVOLVEDYOU"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors mt-8"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FUEHairRestoration;